import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'btx-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
  standalone: false
})
export class TitleComponent implements OnInit {

  @Input("title") title?: string;

  constructor() {
  }

  ngOnInit(): void {
  }

}
